import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const { token, role } = user;    
    // Get roles from route data
    const allowedRoles = next.data['roles'];
    // If the user's role is allowed, return true
    if (allowedRoles && allowedRoles.includes(role)) {
      return true;
    }
    this.router.navigate(['/']);
    return false;
  }
  
}
